export enum Routes {
  home = "/",
  about = "/about",
  skills = "/skills",
  works = "/works",
  contact = "/contact"
}
